/**
 * Writing to the clipboard: text, with HTML beside it when given, so a paste
 * into mail or a word processor keeps the formatting and a paste into a plain
 * field gets the text.
 */
export async function writeClipboard(data: { text: string; html?: string }): Promise<void> {
  if (data.html && typeof ClipboardItem !== 'undefined' && navigator.clipboard?.write) {
    try {
      await navigator.clipboard.write([
        new ClipboardItem({
          'text/plain': new Blob([data.text], { type: 'text/plain' }),
          'text/html': new Blob([data.html], { type: 'text/html' }),
        }),
      ])
      return
    } catch {
      // Some browsers refuse HTML; the text alone is still worth having.
    }
  }
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(data.text)
    return
  }
  // The oldest way, for a page the clipboard API refuses.
  const area = document.createElement('textarea')
  area.value = data.text
  area.style.cssText = 'position:fixed;left:-9999px;top:0'
  document.body.appendChild(area)
  area.select()
  document.execCommand('copy')
  area.remove()
}
